const message = function (message) {
    if (document.body.matches('messageTips')){
        return false
    }
    let div = document.createElement('div')
    div.innerHTML = `<span class="btnMessage">${message}</span>`
    div.className = 'messageTips'
    document.body.appendChild(div)
    setTimeout(()=>{
        let div = document.getElementsByClassName('messageTips')[0]
        document.body.removeChild(div)
    },2000)
}
export default message